export default __webpack_public_path__ + "static/06_嘉宾头像_李超群-d7893cf668e786ddc4a5926f3918df9f.png";